import React from "react";
import { useContent } from "../context/ContentContext";

export default function Blog() {
  const { content } = useContent();
  const b = content.blog || {};
  const posts = b.posts || [];
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{b.title || "News / Blog"}</h1>
      <div className="row g-4">
        {posts.map((post, i) => (
          <div key={i} className="col-md-6">
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-success">{post.title}</h5>
                <p className="card-text"><small className="text-muted">{post.date ? new Date(post.date).toLocaleDateString() : ""}</small></p>
                <p className="card-text">{post.excerpt}</p>
                <a href={post.link || "#"} className="btn btn-link">Read More</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
